import { useEffect, useState } from "react";

const SHOW_MS = 6_000;

const CSS = `
.save-failed { position: fixed; left: 50%; bottom: calc(24px + env(safe-area-inset-bottom)); transform: translateX(-50%); z-index: 600; box-sizing: border-box; width: 420px; max-width: calc(100vw - 32px); display: flex; align-items: center; gap: 12px; padding: 12px 10px 12px 14px; border-radius: 14px; background: #20242E; color: #fff; box-shadow: 0 10px 28px rgba(32, 36, 46, 0.28); }
.save-failed > .ms { flex: 0 0 auto; font-size: 22px; color: #FF8A9B; }
.save-failed__msg { flex: 1; min-width: 0; font-size: 14px; font-weight: 800; line-height: 1.25; }
.save-failed__msg span { display: block; margin-top: 2px; font-size: 12.5px; font-weight: 600; line-height: 1.3; color: #C4C7D1; }
.save-failed button { flex: 0 0 auto; width: 44px; height: 44px; border: none; border-radius: 12px; background: transparent; color: #fff; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.save-failed button .ms { font-size: 20px; }
@media (max-width: 767px) {
  .save-failed { left: 16px; right: 16px; width: auto; max-width: none; transform: none; bottom: calc(96px + env(safe-area-inset-bottom)); }
}
`;

/** Canvas v2-o-save-failed: a change shown at once that the server then refused. `event` is @cliqsuite/db's SAVE_REFUSED_EVENT. */
export function SaveFailedNotice({ event }: { event: string }) {
  const [shownAt, setShownAt] = useState(0);

  useEffect(() => {
    const show = () => setShownAt(Date.now());
    window.addEventListener(event, show);
    return () => window.removeEventListener(event, show);
  }, [event]);

  useEffect(() => {
    if (!shownAt) return;
    const timer = setTimeout(() => setShownAt(0), SHOW_MS);
    return () => clearTimeout(timer);
  }, [shownAt]);

  if (!shownAt) return null;
  return (
    <div className="save-failed" role="alert">
      <style>{CSS}</style>
      <span className="ms" aria-hidden="true">error</span>
      <div className="save-failed__msg">
        Couldn&rsquo;t save that change
        <span>It&rsquo;s back to how it was.</span>
      </div>
      <button type="button" aria-label="Dismiss" onClick={() => setShownAt(0)}>
        <span className="ms" aria-hidden="true">close</span>
      </button>
    </div>
  );
}
